/* Matriz theme: comportamento da loja (port em JS puro dos componentes React da OG). */
(function () {
  'use strict';

  var MZ = window.MZ || (window.MZ = {});
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (key, fallback) { try { var v = localStorage.getItem(key); return v == null ? fallback : JSON.parse(v); } catch (e) { return fallback; } },
    set: function (key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage blocked */ } },
  };
  var rootUrl = function (path) {
    var base = (MZ.routes && MZ.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + String(path || '').replace(/^\//, '');
  };
  var lockScroll = function (on) { document.body.style.overflow = on ? 'hidden' : ''; };
  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };

  /* ---------- dinheiro ---------- */
  MZ.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || MZ.moneyFormat || '${{amount}}';
    var place = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch ((fmt.match(place) || [])[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(place, value).replace(/<[^>]+>/g, '');
  };
  // Formato dos cards: "$ 60" (sem zeros à direita).
  MZ.formatCard = function (cents) {
    var n = Number(cents) / 100;
    var txt = n % 1 === 0 ? String(n) : n.toFixed(2);
    return (MZ.currencySymbol || '$') + ' ' + txt;
  };

  /* ---------- header: sombra ao rolar, barra promo rotativa ---------- */
  function initHeader() {
    var header = $('[data-mz-header]');
    var promo = $('[data-mz-promo]');
    var onScroll = function () {
      var scrolled = window.scrollY > 40;
      if (header) header.classList.toggle('shadow-sm', scrolled);
      if (promo) {
        promo.classList.toggle('h-0', scrolled);
        promo.classList.toggle('overflow-hidden', scrolled);
        promo.classList.toggle('h-10', !scrolled);
        promo.classList.toggle('lg:h-9', !scrolled);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var text = $('[data-mz-promo-text]');
    if (text) {
      var messages = [];
      try { messages = JSON.parse(text.getAttribute('data-messages') || '[]').filter(Boolean); } catch (e) { messages = []; }
      if (messages.length > 1) {
        var i = 0;
        setInterval(function () { i = (i + 1) % messages.length; text.textContent = messages[i]; }, 4000);
      }
    }

    var top = $('[data-mz-top]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- menu mobile ---------- */
  var Menu = {
    set: function (open) {
      var overlay = $('[data-mz-menu-overlay]');
      var panel = $('[data-mz-menu-panel]');
      if (!overlay || !panel) return;
      overlay.classList.toggle('opacity-100', open);
      overlay.classList.toggle('opacity-0', !open);
      overlay.classList.toggle('pointer-events-none', !open);
      panel.classList.toggle('translate-x-0', open);
      panel.classList.toggle('-translate-x-full', !open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      lockScroll(open);
    },
  };

  /* ---------- sacola ---------- */
  var Cart = MZ.cart = {
    isOpen: false,
    set: function (open) {
      var overlay = $('[data-mz-cart-overlay]');
      var panel = $('[data-mz-cart-panel]');
      if (!overlay || !panel) return;
      Cart.isOpen = open;
      overlay.classList.toggle('opacity-100', open);
      overlay.classList.toggle('opacity-0', !open);
      overlay.classList.toggle('pointer-events-none', !open);
      panel.classList.toggle('translate-x-0', open);
      panel.classList.toggle('translate-x-full', !open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      lockScroll(open);
    },
    open: function () { Cart.set(true); },
    close: function () { Cart.set(false); },
    refresh: function () {
      return fetch(rootUrl('?section_id=mz-cart-drawer'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-mz-cart-inner]', doc);
          var current = $('[data-mz-cart-inner]');
          if (!fresh || !current) return;
          current.replaceWith(fresh);
          var count = parseInt(fresh.getAttribute('data-count') || '0', 10) || 0;
          $$('[data-mz-cart-count]').forEach(function (el) { el.textContent = String(count); el.hidden = count === 0; });
          document.dispatchEvent(new CustomEvent('mz:cart', { detail: { count: count } }));
        });
    },
    post: function (url, body) {
      return fetch(url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
          return j;
        });
      });
    },
    add: function (variantId, quantity, properties) {
      var item = { id: Number(variantId), quantity: quantity || 1 };
      if (properties) item.properties = properties;
      return Cart.post(MZ.routes.cartAdd, { items: [item] }).then(function () { return Cart.refresh(); }).then(function () { Cart.open(); });
    },
    change: function (key, quantity) {
      return Cart.post(MZ.routes.cartChange, { id: key, quantity: quantity }).then(function () { return Cart.refresh(); });
    },
  };

  /* ---------- wishlist (por navegador) ---------- */
  var WISH_KEY = 'mz-wishlist';
  var Wish = MZ.wishlist = {
    items: function () { var v = store.get(WISH_KEY, []); return Array.isArray(v) ? v : []; },
    has: function (handle) { return Wish.items().some(function (i) { return i.handle === handle; }); },
    toggle: function (handle) {
      var items = Wish.items();
      var next = Wish.has(handle) ? items.filter(function (i) { return i.handle !== handle; }) : items.concat([{ handle: handle, addedAt: Date.now() }]);
      store.set(WISH_KEY, next);
      Wish.paint();
      document.dispatchEvent(new CustomEvent('mz:wishlist'));
    },
    paint: function (root) {
      var items = Wish.items();
      $$('[data-mz-wish]', root).forEach(function (btn) {
        var on = items.some(function (i) { return i.handle === btn.getAttribute('data-mz-wish'); });
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? MZ.strings.removeWish : MZ.strings.saveWish);
        var svg = $('svg', btn);
        if (svg) svg.classList.toggle('fill-black', on);
        if (btn.hasAttribute('data-mz-wish-pdp')) {
          btn.classList.toggle('border-black', on);
          btn.classList.toggle('border-[#E5E5E5]', !on);
        } else {
          btn.classList.toggle('opacity-100', on);
          btn.classList.toggle('opacity-0', !on);
        }
      });
      $$('[data-mz-wish-count]').forEach(function (el) { el.textContent = String(items.length); el.hidden = items.length === 0; });
    },
  };

  function initWishlistPage() {
    var grid = $('[data-mz-wishlist-grid]');
    if (!grid) return;
    var empty = $('[data-mz-wishlist-empty]');
    var count = $('[data-mz-wishlist-count]');
    var render = function () {
      var items = Wish.items();
      if (count) count.textContent = items.length ? items.length + ' saved' : count.getAttribute('data-empty');
      if (empty) empty.hidden = items.length > 0;
      grid.hidden = items.length === 0;
      var wanted = items.map(function (i) { return i.handle; });
      $$('[data-mz-wishlist-item]', grid).forEach(function (el) { if (wanted.indexOf(el.getAttribute('data-mz-wishlist-item')) === -1) el.remove(); });
      wanted.forEach(function (handle) {
        if ($('[data-mz-wishlist-item="' + handle + '"]', grid)) return;
        var slot = document.createElement('div');
        slot.setAttribute('data-mz-wishlist-item', handle);
        grid.appendChild(slot);
        fetch(rootUrl('products/' + encodeURIComponent(handle) + '?section_id=mz-wishlist-item'))
          .then(function (r) { if (!r.ok) throw new Error('gone'); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = $('[data-mz-wishlist-card]', doc);
            if (!card) throw new Error('empty');
            slot.appendChild(card);
          })
          .catch(function () { slot.remove(); });
      });
    };
    render();
    document.addEventListener('mz:wishlist', render);
  }

  /* ---------- busca ---------- */
  var Search = {
    timer: null,
    set: function (open) {
      var box = $('[data-mz-search]');
      if (!box) return;
      box.hidden = !open;
      lockScroll(open);
      var input = $('[data-mz-search-input]', box);
      if (open) { setTimeout(function () { if (input) input.focus(); }, 100); } else if (input) { input.value = ''; Search.show('popular'); }
    },
    show: function (what) {
      var box = $('[data-mz-search]');
      if (!box) return;
      $('[data-mz-search-loading]', box).hidden = what !== 'loading';
      $('[data-mz-search-results]', box).hidden = what !== 'results';
      $('[data-mz-search-popular]', box).hidden = what !== 'popular';
    },
    run: function (term) {
      var box = $('[data-mz-search]');
      var out = $('[data-mz-search-results]', box);
      if (!term || term.length < 2) { Search.show('popular'); return; }
      Search.show('loading');
      var url = MZ.routes.predictive + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var products = (((json || {}).resources || {}).results || {}).products || [];
          if (!products.length) {
            out.innerHTML = '<div class="text-center py-12"><p class="text-[15px] text-[#767677]">' + escapeHtml(MZ.strings.noResults) + ' "<span class="text-black font-medium">' + escapeHtml(term) + '</span>"</p><p class="text-[13px] text-[#999] mt-2">' + escapeHtml(MZ.strings.tryDifferent) + '</p></div>';
            Search.show('results');
            return;
          }
          var cards = products.map(function (p) {
            var price = Math.round(parseFloat(p.price) * 100);
            var compare = Math.round(parseFloat(p.compare_at_price_max || p.compare_at_price_min || 0) * 100);
            var sale = compare > price;
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=480';
            return '<a href="' + escapeHtml(p.url) + '" class="group text-left block">'
              + '<div class="relative aspect-square bg-[#ECEBE9] overflow-hidden mb-2">'
              + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" class="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy">' : '')
              + '<div class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none"><div class="absolute inset-0 border border-black"></div><div class="absolute inset-[1px] border border-white"></div></div>'
              + '</div><div class="space-y-0.5">'
              + '<p class="text-[13px] font-bold text-black">' + escapeHtml(MZ.formatCard(price))
              + (sale ? '<span class="ml-2 text-[#767677] line-through font-normal text-[12px]">' + escapeHtml(MZ.formatCard(compare)) + '</span>' : '')
              + '</p><p class="text-[13px] text-black leading-snug line-clamp-2">' + escapeHtml(p.title) + '</p>'
              + (p.type ? '<p class="text-[12px] text-[#767677]">' + escapeHtml(p.type) + '</p>' : '')
              + '</div></a>';
          }).join('');
          var more = products.length >= 8
            ? '<a href="' + MZ.routes.search + '?type=product&q=' + encodeURIComponent(term) + '" class="mt-6 inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-widest hover:opacity-60 transition-opacity">' + escapeHtml(MZ.strings.viewAll) + ' &rarr;</a>'
            : '';
          out.innerHTML = '<div><p class="text-[12px] font-bold uppercase tracking-widest text-[#767677] mb-4">' + products.length + ' ' + escapeHtml(products.length === 1 ? MZ.strings.result : MZ.strings.results) + '</p><div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">' + cards + '</div>' + more + '</div>';
          Search.show('results');
        })
        .catch(function () { Search.show('popular'); });
    },
  };

  /* ---------- carrosséis de produto ---------- */
  function initCarousel(root) {
    if (root.__mz) return;
    root.__mz = true;
    var track = $('[data-mz-track]', root);
    var prev = $('[data-mz-prev]', root);
    var next = $('[data-mz-next]', root);
    var thumb = $('[data-mz-thumb]', root);
    if (!track) return;
    var colsLg = parseInt(root.getAttribute('data-cols') || '4', 10);
    var minThumb = parseInt(root.getAttribute('data-min-thumb') || '15', 10);
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var progress = max > 0 ? track.scrollLeft / max : 0;
      var count = track.children.length;
      var visible = window.innerWidth >= 1024 ? colsLg : window.innerWidth >= 768 ? Math.min(colsLg, 3) : 2;
      var width = Math.max(minThumb, 100 / Math.max(count / visible, 1));
      if (thumb) { thumb.style.width = width + '%'; thumb.style.left = progress * (100 - width) + '%'; }
      if (prev && prev.hasAttribute('data-auto-hide')) {
        var left = track.scrollLeft > 2;
        prev.classList.toggle('opacity-100', left); prev.classList.toggle('opacity-0', !left); prev.classList.toggle('pointer-events-none', !left);
      }
      if (next && next.hasAttribute('data-auto-hide')) {
        var right = track.scrollLeft < max - 2;
        next.classList.toggle('opacity-100', right); next.classList.toggle('opacity-0', !right); next.classList.toggle('pointer-events-none', !right);
      }
    };
    var step = function (dir) {
      var card = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap || '8') || 0;
      var w = card ? card.offsetWidth + gap : 289;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    track.addEventListener('scroll', update, { passive: true });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
    root.__mzUpdate = update;
  }

  /* ---------- hero rotativo ---------- */
  function initHero(root) {
    var slides = $$('[data-mz-slide]', root);
    if (slides.length < 2) return;
    var dots = $$('[data-mz-dot]', root);
    var ring = $('[data-mz-ring]', root);
    var ringNumber = $('[data-mz-ring-number]', root);
    var ringCircle = $('[data-mz-ring-circle]', root);
    var interval = parseInt(root.getAttribute('data-interval') || '4000', 10);
    var index = 0;
    var paused = false;
    var go = function (i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('opacity-100', on); s.classList.toggle('z-10', on);
        s.classList.toggle('opacity-0', !on); s.classList.toggle('z-0', !on); s.classList.toggle('pointer-events-none', !on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, n) {
        var on = n === index;
        d.setAttribute('aria-current', on ? 'true' : 'false');
        ['bg-white', 'text-black', 'border-white'].forEach(function (c) { d.classList.toggle(c, on); });
        ['bg-black/30', 'text-white', 'border-white/70', 'hover:bg-black/50'].forEach(function (c) { d.classList.toggle(c, !on); });
      });
      if (ringNumber) ringNumber.textContent = String(index + 1);
      if (ringCircle) { ringCircle.style.animation = 'none'; void ringCircle.getBoundingClientRect(); ringCircle.style.animation = 'mzHeroRing ' + interval + 'ms linear forwards'; }
    };
    setInterval(function () { if (!paused) go(index + 1); }, interval);
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX == null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
    });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    if (ring) ring.addEventListener('click', function () { go(index + 1); });
    go(0);
  }

  /* ---------- abas (Trending now) ---------- */
  function initTabs(root) {
    var tabs = $$('[data-mz-tab]', root);
    var panels = $$('[data-mz-tab-panel]', root);
    var select = function (id) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-mz-tab') === id;
        t.classList.toggle('border-black', on);
        t.classList.toggle('text-black', on);
        t.classList.toggle('border-transparent', !on);
        t.classList.toggle('text-[#767677]', !on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-mz-tab-panel') === id;
        p.hidden = !on;
        if (on && p.hasAttribute('data-mz-lazy-row')) {
          var url = p.getAttribute('data-mz-lazy-row');
          p.removeAttribute('data-mz-lazy-row');
          fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var row = $('[data-mz-row]', doc);
              if (!row) return;
              p.innerHTML = row.innerHTML;
              p.setAttribute('data-mz-carousel', '');
              initCarousel(p);
              Wish.paint(p);
            })
            .catch(function () { p.setAttribute('data-mz-lazy-row', url); });
        }
        if (on) { var track = $('[data-mz-track]', p); if (track) track.scrollLeft = 0; if (p.__mzUpdate) p.__mzUpdate(); }
      });
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { select(t.getAttribute('data-mz-tab')); }); });
  }

  /* ---------- accordion com altura animada ---------- */
  function toggleAccordion(btn) {
    var panel = btn.nextElementSibling;
    if (!panel || !panel.hasAttribute('data-mz-acc-panel')) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    var chevron = $('[data-mz-acc-icon]', btn) || $('svg:last-of-type', btn);
    if (chevron) chevron.classList.toggle('rotate-180', !open);
    if (panel.hasAttribute('data-instant')) { panel.hidden = open; return; }
    panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    if (!open) {
      var settle = function () { if (btn.getAttribute('aria-expanded') === 'true') panel.style.maxHeight = panel.scrollHeight + 'px'; };
      $$('img', panel).forEach(function (img) { if (!img.complete) img.addEventListener('load', settle, { once: true }); });
      setTimeout(settle, 350);
    }
  }

  /* ---------- modais ---------- */
  var Modal = MZ.modal = {
    open: function (id) { var m = $('[data-mz-modal="' + id + '"]'); if (m) { m.hidden = false; lockScroll(true); } },
    close: function (m) { if (m) { m.hidden = true; lockScroll(false); } },
  };

  /* ---------- página de produto ---------- */
  function initProduct(root) {
    var dataEl = $('[data-mz-product-json]', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('[data-mz-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var button = $('[data-mz-add-button]', root);
    var buttonLabel = $('[data-mz-add-label]', root);
    var buttonArrow = $('[data-mz-add-arrow]', root);
    var error = $('[data-mz-add-error]', root);
    var priceBox = $('[data-mz-pdp-price]', root);
    var inventory = {};
    try { inventory = JSON.parse(($('[data-mz-inventory-json]', root) || {}).textContent || '{}'); } catch (e) { inventory = {}; }

    var current = product.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || product.variants[0];
    var selected = current.options.slice();

    var findVariant = function () {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0] || null;
    };
    var valueAvailable = function (optionIndex, value) {
      return product.variants.some(function (v) {
        if (!v.available || v.options[optionIndex] !== value) return false;
        return v.options.every(function (o, i) { return i === optionIndex || i > optionIndex || o === selected[i]; });
      });
    };

    var paintOptions = function () {
      $$('[data-mz-option]', root).forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-mz-option'), 10);
        var value = btn.getAttribute('data-value');
        var on = selected[i] === value;
        var ok = valueAvailable(i, value);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (btn.hasAttribute('data-swatch')) {
          ['outline', 'outline-2', 'outline-black', 'outline-offset-[-2px]'].forEach(function (c) { btn.classList.toggle(c, on); });
          btn.classList.toggle('opacity-40', !ok && !on);
        } else {
          ['bg-black', 'text-white', 'border-black'].forEach(function (c) { btn.classList.toggle(c, on); });
          ['border-[#E5E5E5]', 'hover:border-black'].forEach(function (c) { btn.classList.toggle(c, !on); });
          btn.classList.toggle('text-[#767677]', !ok && !on);
          btn.classList.toggle('line-through', !ok && !on);
        }
      });
      $$('[data-mz-option-label]', root).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-mz-option-label'), 10);
        el.textContent = selected[i] || '';
      });
    };

    var paintPrice = function (v) {
      if (!priceBox || !v) return;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (sale) {
        var off = Math.round((1 - v.price / v.compare_at_price) * 100);
        priceBox.innerHTML = '<div class="flex items-center gap-2 flex-wrap"><span class="text-[24px] font-bold text-black">' + MZ.formatMoney(v.price) + '</span>'
          + '<span class="text-[16px] text-[#767677] line-through">' + MZ.formatMoney(v.compare_at_price) + '</span>'
          + '<span class="bg-sale text-white text-[12px] font-bold px-1.5 py-0.5">-' + off + '%</span></div>'
          + '<p class="text-[14px] text-green-600 font-medium mt-1">You save ' + MZ.formatMoney(v.compare_at_price - v.price) + '</p>';
      } else {
        priceBox.innerHTML = '<p class="text-[20px] font-bold">' + MZ.formatMoney(v.price) + '</p>';
      }
    };

    var paintStock = function (v) {
      var n = v ? inventory[v.id] : null;
      $$('[data-mz-stock-line]', root).forEach(function (el) {
        var show = typeof n === 'number' && n > 0 && n <= parseInt(el.getAttribute('data-max') || '50', 10);
        el.hidden = !show;
        var num = $('[data-mz-stock-number]', el);
        if (show && num) num.textContent = String(n);
      });
    };

    var showMedia = function (id) {
      var stage = $('[data-mz-gallery-main]', root);
      var thumb = $('[data-mz-thumb][data-media-id="' + id + '"]', root);
      if (!stage || !thumb) return;
      stage.src = thumb.getAttribute('data-full') || stage.src;
      stage.removeAttribute('srcset');
      stage.alt = thumb.getAttribute('data-alt') || '';
      $$('[data-mz-thumb]', root).forEach(function (t) {
        var on = t === thumb;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.classList.toggle('border-black', on);
        t.classList.toggle('border-transparent', !on);
      });
      var row = $('[data-mz-thumbs]', root);
      if (row) {
        var left = thumb.offsetLeft - (row.clientWidth - thumb.offsetWidth) / 2;
        row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    };

    var paintGallery = function (v) {
      if (!v || !v.featured_media) return;
      showMedia(String(v.featured_media.id));
    };

    var paintDemand = function (v) {
      var num = $('[data-mz-demand-number]', root);
      if (!num || !v) return;
      num.textContent = String((Number(v.id) % 9) + 4);
    };

    var apply = function (fromUser) {
      var v = findVariant();
      paintOptions();
      if (!v) {
        if (button) { button.disabled = true; button.classList.add('bg-[#767677]', 'cursor-not-allowed'); button.classList.remove('bg-black', 'hover:bg-[#333]'); }
        if (buttonLabel) buttonLabel.textContent = MZ.strings.soldOut;
        if (buttonArrow) buttonArrow.hidden = true;
        return;
      }
      current = v;
      if (idInput) idInput.value = v.id;
      paintPrice(v);
      paintStock(v);
      paintDemand(v);
      if (button) {
        button.disabled = !v.available;
        button.classList.toggle('bg-[#767677]', !v.available);
        button.classList.toggle('cursor-not-allowed', !v.available);
        button.classList.toggle('bg-black', v.available);
        button.classList.toggle('hover:bg-[#333]', v.available);
      }
      if (buttonLabel) buttonLabel.textContent = v.available ? MZ.strings.addToBag : MZ.strings.soldOut;
      if (buttonArrow) buttonArrow.hidden = !v.available;
      if (fromUser) {
        paintGallery(v);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
      }
    };

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-mz-option]');
      if (opt && root.contains(opt)) {
        e.preventDefault();
        selected[parseInt(opt.getAttribute('data-mz-option'), 10)] = opt.getAttribute('data-value');
        // Se a combinação não existe, cai na primeira variante que tem o valor clicado.
        if (!findVariant()) {
          var i = parseInt(opt.getAttribute('data-mz-option'), 10);
          var alt = product.variants.filter(function (v) { return v.options[i] === selected[i] && v.available; })[0]
            || product.variants.filter(function (v) { return v.options[i] === selected[i]; })[0];
          if (alt) selected = alt.options.slice();
        }
        apply(true);
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        if (error) error.hidden = true;
        button.disabled = true;
        Cart.add(current.id, 1)
          .catch(function (err) { if (error) { error.textContent = err.message; error.hidden = false; } })
          .then(function () { button.disabled = false; });
      });
    }

    /* galeria: foto grande, miniaturas embaixo. A cor da variante chama showMedia. */
    $$('[data-mz-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-media-id')); });
    });
    var thumbRow = $('[data-mz-thumbs]', root);
    var thumbPrev = $('[data-mz-thumbs-prev]', root);
    var thumbNext = $('[data-mz-thumbs-next]', root);
    if (thumbRow && thumbPrev) thumbPrev.addEventListener('click', function () { thumbRow.scrollBy({ left: -240, behavior: 'smooth' }); });
    if (thumbRow && thumbNext) thumbNext.addEventListener('click', function () { thumbRow.scrollBy({ left: 240, behavior: 'smooth' }); });

    /* zoom no hover da foto grande */
    $$('[data-mz-zoom]', root).forEach(function (box) {
      var img = $('img', box);
      if (!img) return;
      box.addEventListener('mouseenter', function () { img.style.transition = 'transform 0.1s ease-out'; img.style.transform = 'scale(2)'; });
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      });
      box.addEventListener('mouseleave', function () { img.style.transition = 'transform 0.3s ease-out'; img.style.transform = 'scale(1)'; img.style.transformOrigin = 'center center'; });
    });
    var back = $('[data-mz-back]', root);
    if (back) back.addEventListener('click', function () { if (window.history.length > 1) window.history.back(); else window.location.href = rootUrl(''); });

    apply(false);

    /* popup de estoque final: abre na 1a página de produto que o visitante vê e depois só a cada N páginas
       de produto (N vem do tema, padrão 6). O número de unidades dentro dele continua sendo o estoque real. */
    var popup = $('[data-mz-modal="demand-popup"]');
    if (popup && MZ.stockEnabled && current && current.available) {
      var every = parseInt(popup.getAttribute('data-every') || '6', 10) || 6;
      var visits = (parseInt(store.get('mz-closing-visits', 0), 10) || 0) + 1;
      store.set('mz-closing-visits', visits);
      if (visits === 1 || (visits - 1) % every === 0) setTimeout(function () { Modal.open('demand-popup'); }, 1800);
    }
  }

  /* ---------- coleção: filtros, ordenação e "load more" por AJAX ---------- */
  function initCollection(root) {
    var sectionId = root.getAttribute('data-section-id');
    var load = function (url, push) {
      root.classList.add('opacity-60');
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-mz-collection]', doc);
          if (!fresh) { window.location.href = url; return; }
          var drawerOpen = !!$('[data-mz-filter-drawer]:not([hidden])', root);
          root.innerHTML = fresh.innerHTML;
          if (drawerOpen) { var d = $('[data-mz-filter-drawer]', root); if (d) d.hidden = false; }
          root.classList.remove('opacity-60');
          Wish.paint(root);
          if (push) { u.searchParams.delete('section_id'); window.history.pushState({}, '', u.pathname + (u.search || '')); }
        })
        .catch(function () { window.location.href = url; });
    };
    var formUrl = function (form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      var qs = params.toString();
      return form.getAttribute('action') + (qs ? '?' + qs : '');
    };

    root.addEventListener('change', function (e) {
      var form = e.target.closest('[data-mz-filter-form]');
      if (!form || e.target.type === 'number') return;
      load(formUrl(form), true);
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-mz-filter-form]');
      if (!form) return;
      e.preventDefault();
      load(formUrl(form), true);
    });
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-mz-ajax-link]');
      if (link) {
        e.preventDefault();
        var href = link.getAttribute('href');
        // Filtro por tag troca o caminho da URL: a ordenação e o preço escolhidos vão junto.
        if (link.hasAttribute('data-mz-keep-query')) {
          var keep = new URLSearchParams(window.location.search);
          keep.delete('page'); keep.delete('section_id');
          if (keep.toString()) href += (href.indexOf('?') === -1 ? '?' : '&') + keep.toString();
        }
        load(href, true);
        return;
      }

      var sort = e.target.closest('[data-mz-sort]');
      if (sort) {
        var su = new URL(window.location.href);
        su.searchParams.set('sort_by', sort.getAttribute('data-mz-sort'));
        su.searchParams.delete('page');
        load(su.pathname + su.search, true);
        return;
      }

      var sortToggle = e.target.closest('[data-mz-sort-toggle]');
      if (sortToggle) { var menu = $('[data-mz-sort-menu]', root); if (menu) menu.hidden = !menu.hidden; return; }

      var group = e.target.closest('[data-mz-filter-group]');
      if (group) {
        var body = group.nextElementSibling;
        var open = group.getAttribute('aria-expanded') === 'true';
        group.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) body.hidden = open;
        var icon = $('svg', group);
        if (icon) icon.classList.toggle('rotate-180', !open);
        return;
      }

      var drawerOpen = e.target.closest('[data-mz-filter-open]');
      if (drawerOpen) { var d = $('[data-mz-filter-drawer]', root); if (d) { d.hidden = false; lockScroll(true); } return; }
      var drawerClose = e.target.closest('[data-mz-filter-close]');
      if (drawerClose) { var d2 = $('[data-mz-filter-drawer]', root); if (d2) { d2.hidden = true; lockScroll(false); } return; }

      var more = e.target.closest('[data-mz-more]');
      if (more) {
        e.preventDefault();
        more.disabled = true;
        var u = new URL(more.getAttribute('data-mz-more'), window.location.origin);
        u.searchParams.set('section_id', sectionId);
        fetch(u.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = $('[data-mz-grid]', root);
            $$('[data-mz-grid] > *', doc).forEach(function (card) { grid.appendChild(card); });
            var nextBtn = $('[data-mz-more]', doc);
            var wrap = more.parentElement;
            if (nextBtn) more.replaceWith(nextBtn); else wrap.remove();
            Wish.paint(grid);
          })
          .catch(function () { more.disabled = false; });
      }
    });
    window.addEventListener('popstate', function () { load(window.location.href, false); });
  }

  /* ---------- recomendações da Shopify na página de produto ---------- */
  function initRecs(root) {
    var url = root.getAttribute('data-url');
    if (!url || root.__mz) return;
    root.__mz = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-mz-recs]', doc);
        if (!fresh || !fresh.children.length) return;
        root.innerHTML = fresh.innerHTML;
        $$('[data-mz-carousel]', root).forEach(initCarousel);
        Wish.paint(root);
      })
      .catch(function () { /* sem recomendações: a fileira simplesmente não aparece */ });
  }

  /* ---------- cookies ---------- */
  function initCookies() {
    var bar = $('[data-mz-cookies]');
    if (!bar) return;
    var seen = null;
    try { seen = localStorage.getItem('cookie_consent'); } catch (e) { seen = 'blocked'; }
    if (!seen) setTimeout(function () { bar.hidden = false; }, 500);
    $$('[data-mz-cookies-accept]', bar).forEach(function (btn) {
      btn.addEventListener('click', function () {
        try { localStorage.setItem('cookie_consent', btn.getAttribute('data-mz-cookies-accept')); } catch (e) { /* noop */ }
        bar.hidden = true;
      });
    });
  }

  /* ---------- cliques delegados ---------- */
  function initDelegates() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var el;

      if ((el = t.closest('[data-mz-wish]'))) { e.preventDefault(); e.stopPropagation(); Wish.toggle(el.getAttribute('data-mz-wish')); return; }

      // Miniatura de cor no card: troca a foto e aponta o card para aquela variante, sem sair da página.
      if ((el = t.closest('[data-mz-swatch]'))) {
        e.preventDefault(); e.stopPropagation();
        var card = el.closest('[data-mz-card]');
        if (!card) return;
        var img = $('[data-mz-card-img]', card);
        if (img) { img.src = el.getAttribute('data-img'); img.srcset = el.getAttribute('data-srcset') || ''; }
        card.setAttribute('href', el.getAttribute('data-href'));
        $$('[data-mz-swatch]', card).forEach(function (s) {
          var on = s === el;
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
          s.classList.toggle('border-black', on);
          s.classList.toggle('border-transparent', !on);
          s.classList.toggle('hover:border-[#9A9A9A]', !on);
        });
        return;
      }

      if (t.closest('[data-mz-menu-open]')) { Menu.set(true); return; }
      if (t.closest('[data-mz-menu-close]') || t.matches('[data-mz-menu-overlay]')) { Menu.set(false); return; }
      if ((el = t.closest('[data-mz-menu-acc]'))) {
        var sub = el.parentElement.nextElementSibling;
        var open = el.getAttribute('aria-expanded') === 'true';
        el.setAttribute('aria-expanded', open ? 'false' : 'true');
        $('svg', el).classList.toggle('rotate-90', !open);
        if (sub) { sub.classList.toggle('max-h-[500px]', !open); sub.classList.toggle('max-h-0', open); }
        return;
      }

      if (t.closest('[data-mz-search-open]')) { Search.set(true); return; }
      if (t.closest('[data-mz-search-close]') || t.matches('[data-mz-search]')) { Search.set(false); return; }
      if ((el = t.closest('[data-mz-search-term]'))) {
        var input = $('[data-mz-search-input]');
        input.value = el.getAttribute('data-mz-search-term');
        Search.run(input.value);
        return;
      }

      if (t.closest('[data-mz-cart-open]')) { e.preventDefault(); Cart.open(); return; }
      if (t.closest('[data-mz-cart-close]') || t.matches('[data-mz-cart-overlay]')) { Cart.close(); return; }
      if ((el = t.closest('[data-mz-qty]'))) {
        var line = el.closest('[data-mz-line]');
        if (line) { el.disabled = true; Cart.change(line.getAttribute('data-mz-line'), parseInt(el.getAttribute('data-mz-qty'), 10)).catch(function () { Cart.refresh(); }); }
        return;
      }
      if ((el = t.closest('[data-mz-upsell-toggle]'))) {
        e.preventDefault();
        var pop = $('[data-mz-upsell-pop]', el.closest('[data-mz-upsell]'));
        $$('[data-mz-upsell-pop]').forEach(function (p) { if (p !== pop) p.hidden = true; });
        if (pop) pop.hidden = !pop.hidden;
        return;
      }
      if ((el = t.closest('[data-mz-add]'))) {
        e.preventDefault();
        el.disabled = true;
        Cart.add(el.getAttribute('data-mz-add'), 1).catch(function () { /* fica na sacola atual */ }).then(function () { el.disabled = false; });
        return;
      }

      if ((el = t.closest('[data-mz-acc]'))) { toggleAccordion(el); return; }

      if ((el = t.closest('[data-mz-modal-open]'))) { e.preventDefault(); Modal.open(el.getAttribute('data-mz-modal-open')); return; }
      if (t.closest('[data-mz-modal-close]')) { Modal.close(t.closest('[data-mz-modal]')); return; }
      if (t.matches('[data-mz-modal]')) { Modal.close(t); return; }

      if (!t.closest('[data-mz-upsell]')) $$('[data-mz-upsell-pop]').forEach(function (p) { p.hidden = true; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      Menu.set(false); Cart.close(); Search.set(false);
      $$('[data-mz-modal]').forEach(function (m) { if (!m.hidden) Modal.close(m); });
    });

    var input = $('[data-mz-search-input]');
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(Search.timer);
        var value = input.value.trim();
        Search.timer = setTimeout(function () { Search.run(value); }, 300);
      });
    }

    // Voltando do checkout pelo botão "voltar" (bfcache): a sacola pode ter mudado.
    window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });
  }

  function initReviews(root) {
    if (!root || root.getAttribute('data-mz-reviews-ready')) return;
    root.setAttribute('data-mz-reviews-ready', '1');
    var handle = root.getAttribute('data-product') || '';
    var list = $('[data-mz-reviews-list]', root);
    var toggle = $('[data-mz-reviews-toggle]', root);
    var panel = $('[data-mz-reviews-panel]', root);
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        var icon = $('svg', toggle);
        if (icon) icon.classList.toggle('rotate-180', open);
      });
    }
    var more = $('[data-mz-reviews-more]', root);
    if (more) more.addEventListener('click', function (e) { e.preventDefault(); });

    var cards = function () { return $$('[data-mz-review]', list || root); };
    var paintVote = function (card) {
      var saved = '';
      try { saved = localStorage.getItem('mz-rev:' + handle + ':' + card.getAttribute('data-id')) || ''; } catch (e) { /* noop */ }
      $$('[data-mz-vote]', card).forEach(function (btn) {
        var on = saved === btn.getAttribute('data-mz-vote');
        var base = parseInt(btn.getAttribute('data-base') || '0', 10) || 0;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('text-black', on);
        var n = $('[data-mz-vote-n]', btn);
        if (n) n.textContent = String(base + (on ? 1 : 0));
      });
    };
    cards().forEach(paintVote);

    root.addEventListener('click', function (e) {
      var vote = e.target.closest && e.target.closest('[data-mz-vote]');
      if (vote && root.contains(vote)) {
        var card = vote.closest('[data-mz-review]');
        var key = 'mz-rev:' + handle + ':' + card.getAttribute('data-id');
        var saved = '';
        try { saved = localStorage.getItem(key) || ''; } catch (err) { /* noop */ }
        var next = saved === vote.getAttribute('data-mz-vote') ? '' : vote.getAttribute('data-mz-vote');
        try { localStorage.setItem(key, next); } catch (err) { /* noop */ }
        paintVote(card);
        return;
      }
      var report = e.target.closest && e.target.closest('[data-mz-report]');
      if (report && root.contains(report)) {
        var label = $('span', report);
        if (label) label.textContent = 'Reported';
        report.disabled = true;
      }
    });

    var sort = $('[data-mz-reviews-sort]', root);
    if (sort && list) {
      var applySort = function () {
        var mode = sort.value;
        var items = cards();
        items.sort(function (a, b) {
          if (mode === 'high' || mode === 'low') {
            var d = (parseInt(a.getAttribute('data-stars'), 10) || 0) - (parseInt(b.getAttribute('data-stars'), 10) || 0);
            return mode === 'high' ? -d || ((a.getAttribute('data-date') < b.getAttribute('data-date')) ? 1 : -1) : d;
          }
          var da = a.getAttribute('data-date') || '';
          var db = b.getAttribute('data-date') || '';
          if (da < db) return mode === 'old' ? -1 : 1;
          if (da > db) return mode === 'old' ? 1 : -1;
          return 0;
        });
        items.forEach(function (el) { list.appendChild(el); });
      };
      sort.addEventListener('change', applySort);
      applySort();
    }
  }

  function initLocale(root) {
    var blocks = root && root.querySelectorAll ? $$('[data-mz-locale]', root) : $$('[data-mz-locale]');
    if (root && root.getAttribute && root.getAttribute('data-mz-locale') != null) blocks = [root].concat(blocks);
    blocks.forEach(function (block) {
      if (block.getAttribute('data-mz-locale-ready')) return;
      block.setAttribute('data-mz-locale-ready', '1');
    });
    if (root) return;
    if (window.Shopify && Shopify.designMode) return;
    if (document.cookie.indexOf('mz-geo=1') !== -1) return;
    var first = document.querySelector('[data-mz-locale]');
    var mapEl = document.querySelector('[data-mz-geo-map]');
    if (!first || !mapEl) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (err) { return; }
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country;
        var country = ((detected && (detected.handle || detected.iso_code)) || '').toUpperCase();
        if (!country) {
          document.cookie = 'mz-geo=1; path=/; max-age=31536000; SameSite=Lax';
          return;
        }
        var wanted = map[country] || 'en';
        var locales = (first.getAttribute('data-mz-locales') || '').toLowerCase().split(',');
        if (locales.indexOf(wanted.toLowerCase()) === -1) wanted = 'en';
        var countriesEl = document.querySelector('[data-mz-countries]');
        var allowed = (countriesEl ? countriesEl.getAttribute('data-mz-countries') : '').split(',');
        var hasCountry = allowed.indexOf(country) !== -1;
        var curCountry = (first.getAttribute('data-country') || '').toUpperCase();
        var curLocale = (first.getAttribute('data-locale') || '').toLowerCase();
        document.cookie = 'mz-geo=1; path=/; max-age=31536000; SameSite=Lax';
        if (!hasCountry || (country === curCountry && wanted.toLowerCase() === curLocale)) return;
        var form = first.querySelector('form');
        if (!form) return;
        form.querySelector('[name="country_code"]').value = country;
        form.querySelector('[name="locale_code"]').value = wanted;
        form.submit();
      })
      .catch(function () {});
  }

  function init() {
    initHeader();
    initLocale();
    initDelegates();
    initCookies();
    Wish.paint();
    $$('[data-mz-carousel]').forEach(initCarousel);
    $$('[data-mz-hero]').forEach(initHero);
    $$('[data-mz-tabs]').forEach(initTabs);
    $$('[data-mz-product]').forEach(initProduct);
    $$('[data-mz-reviews]').forEach(initReviews);
    $$('[data-mz-collection]').forEach(initCollection);
    $$('[data-mz-recs]').forEach(initRecs);
    $$('[data-mz-acc][aria-expanded="true"]').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (panel && !panel.hasAttribute('data-instant')) panel.style.maxHeight = panel.scrollHeight + 'px';
    });
    initWishlistPage();
    if (window.location.hash === '#bag') Cart.open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Editor de temas da Shopify: reinicia o que foi re-renderizado.
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-mz-carousel]', e.target).forEach(initCarousel);
    $$('[data-mz-hero]', e.target).forEach(initHero);
    $$('[data-mz-tabs]', e.target).forEach(initTabs);
    $$('[data-mz-product]', e.target).forEach(initProduct);
    $$('[data-mz-reviews]', e.target).forEach(initReviews);
    initLocale(e.target);
    $$('[data-mz-collection]', e.target).forEach(initCollection);
    Wish.paint(e.target);
  });
})();
